import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Modal from '../../../../core/modules/common/components/Modal';
import SaveReportForm from './SaveReportForm';

// eslint-disable-next-line react/prefer-stateless-function
class SaveReportModal extends Component {
  render() {
    const {
      handleSubmit,
      onCloseModal,
      currentReport,
      headerFormattedMessageId,
    } = this.props;

    return (
      <Modal
        header={
          <FormattedMessage
            id={headerFormattedMessageId}
            tagName="h3"
          />
        }
        closeOnOutsideClick
        onClose={onCloseModal}
      >
        <SaveReportForm
          onSubmit={handleSubmit}
          onCloseModal={onCloseModal}
          currentReport={currentReport}
        />
      </Modal>
    );
  }
}

SaveReportModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  headerFormattedMessageId: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  currentReport: PropTypes.objectOf(PropTypes.shape),
};

export default (SaveReportModal);
